import { useState } from "react";
import classNames from "classnames";
import loginBackground from "../../common/images/login_background.png";
import loginBox from "../../common/images/box.png";
import noccarcLogoWhite from "../../common/images/noccarc_logo_white.png";
import PasswordToggleIcon from "../../common/svgs/PasswordToggleIcon";
import ButtonSpinnerIcon from "../../common/svgs/ButtonSpinnerIcon";
import "./LoginDesktopView.scss";

const LoginDesktopView = ({
    email,
    password,
    errorMsg,
    isSubmitting = false,
    onEmailChange,
    onPasswordChange,
    onSubmit
}) => {
    const [passwordVisible, setPasswordVisible] = useState(false);

    return (
        <div
            className="login-desktop-page"
            style={{ backgroundImage: `url(${loginBackground})` }}
        >
            <div
                className="login-card"
                style={{ "--login-box-image": `url(${loginBox})`, height: "auto", width: "35%", minHeight: "80%" }}
            >
                <div className="login-card-inner">
                    <div className="logo-container">
                        <img
                            className="login-logo"
                            src={noccarcLogoWhite}
                            alt="Noccarc"
                        />
                    </div>

                    <div className="horizon-view-title">HorizonView</div>

                    <h2 className="sub-text">
                        Effortlessly oversee medical devices from any location, on any screen,
                        with HorizonView—an intelligent solution designed for seamless remote
                        monitoring of healthcare equipment.
                    </h2>

                    <div className="login-form-container">
                        <div className="email-container">
                            <input
                                className="login-input email"
                                type="email"
                                placeholder="Email ID"
                                value={email || ""}
                                onChange={onEmailChange}
                                disabled={isSubmitting}
                            />
                        </div>

                        <div className="password-container">
                            <input
                                className="login-input password"
                                type={passwordVisible ? "text" : "password"}
                                placeholder="Password"
                                value={password || ""}
                                onChange={onPasswordChange}
                                disabled={isSubmitting}
                            />
                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() => setPasswordVisible((prev) => !prev)}
                                aria-label={passwordVisible ? "Hide password" : "Show password"}
                                disabled={isSubmitting}
                            >
                                <PasswordToggleIcon
                                    visible={passwordVisible}
                                    className="password-toggle-icon"
                                />
                            </button>
                        </div>

                        <div className="error-msg">{errorMsg}</div>

                        <div className="sign-in-botton-container">
                            <button
                                type="button"
                                className={classNames("sign-in sign-in-botton", {
                                    "sign-in-botton--loading": isSubmitting
                                })}
                                onClick={onSubmit}
                                disabled={isSubmitting}
                                aria-busy={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <>
                                        <ButtonSpinnerIcon className="sign-in-spinner" />
                                        <span>Signing in...</span>
                                    </>
                                ) : (
                                    "Sign In"
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginDesktopView;
